export enum LoadStatus {
  Loading = "loading",
  Ready = "ready",
  Error = "error",
}
